import { jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { Box } from "../Box/Box.mjs";
import { TextContext } from "../Text/TextContext.mjs";
import { HeadingContext } from "../Heading/HeadingContext.mjs";
import { resolveResponsiveRangeProps } from "../../utils/resolveResponsiveRangeProps.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { hiddenOnPrint } from "./Hidden.css.mjs";
import { optimizeResponsiveArray } from "../../utils/optimizeResponsiveArray.mjs";
const Hidden = ({
  children,
  component,
  above,
  below,
  screen,
  print,
  inline: inlineProp,
  data,
  ...restProps
}) => {
  if (process.env.NODE_ENV === "development" && screen) {
    console.warn(
      `You used the "screen" prop on Hidden, but this probably doesn't do what you expect. If you're trying to provide content to screen readers without rendering it to the screen, use the <HiddenVisually> component instead. The "screen" prop is likely to be deprecated in a future release.`
    );
  }
  const inText = Boolean(useContext(TextContext));
  const inHeading = Boolean(useContext(HeadingContext));
  const hiddenOnScreen = Boolean(screen);
  const hiddenOnPrint$1 = Boolean(print);
  const [hiddenOnMobile, hiddenOnTablet, hiddenOnDesktop, hiddenOnWide] = resolveResponsiveRangeProps({ above, below });
  const inline = inlineProp ?? (inText || inHeading);
  const display = inline ? "inline" : "block";
  return /* @__PURE__ */ jsx(
    Box,
    {
      display: hiddenOnScreen ? "none" : optimizeResponsiveArray([
        hiddenOnMobile ? "none" : display,
        hiddenOnTablet ? "none" : display,
        hiddenOnDesktop ? "none" : display,
        hiddenOnWide ? "none" : display
      ]),
      className: hiddenOnPrint$1 ? hiddenOnPrint : void 0,
      component: component || (inline ? "span" : "div"),
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  );
};
export {
  Hidden
};
